import { useDispatch } from "react-redux";

import { API_SEGURIDAD, dataLead, ERROR_CODE_LEAD } from "@/utils/consts";
import { changeErrorData, changeGlobalState } from "@/redux/actions/global";
import { encryptAES } from "@/utils/CryptographyUtils";
import { getCodeSecurity } from "@/utils/apiCanal";
import { sendLead } from "@/redux/actions/vida";
import HTTP_REQUEST from "@/utils/http";
import helpers from "@/utils/helpers";
import url from "@/utils/url";

export const useLeadsService = () => {
  const dispatch = useDispatch();

  const sendLeads = async (dataIn) => {
    let data = { ...dataIn, ...dataLead };

    try {
      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          if (data[key] === null || data[key] === "") {
            delete data[key];
          }
        }
      }
  
      if (data) {
        let origenDatos = false;
      
        if (data.nombres) {
          data.nombres = appendSurnameIfMissing(data.nombres, data.apellidoPaterno);
          data.nombres = appendSurnameIfMissing(data.nombres, data.apellidoMaterno);
          data.nombres = encryptAES(data.nombres, getCodeSecurity());
          origenDatos = true;
      
          delete data.apellidoPaterno;
          delete data.apellidoMaterno;
        } else {
          ['apellidoPaterno', 'apellidoMaterno'].forEach((field) => {
            if (data[field]) {
              data[field] = encryptAES(data[field], getCodeSecurity());
              origenDatos = true;
            }
          });
        }
      
        if (data.fechaNacimiento) {
          data.fechaNacimiento = encryptAES(data.fechaNacimiento, getCodeSecurity());
          origenDatos = true;
        }
      
        if (origenDatos && data.atributos) {
          data.atributos = {
            ...data.atributos,
            origenDatos,
          };
        }
      }
  
      const resp = await HTTP_REQUEST.postWitchTrace(
        url.registerLead,
        data,
        "UTILITARIOS",
        API_SEGURIDAD
      );
      const { payload, status } = await resp.response;
  
      if (payload && status.success) {
        window.idLead = payload.idLead;
        dispatch(sendLead(payload));
        return { status: status.success, idLead: payload.idLead };
      } else {
        dispatch(changeGlobalState(4));
        dispatch(
          changeErrorData({
            error: status.error,
            code: ERROR_CODE_LEAD,
            message: "No se pudo crear el Lead",
          })
        );
        return { status: status.success };
      }
    } catch (error) {
      dispatch(changeGlobalState(4));
      helpers.sendTagError(error, url.registerLead);
    }
  };

  const appendSurnameIfMissing = (name, surname) => {
    const upperCase = (str) => (str || '').toUpperCase();
    if (surname && !upperCase(name).includes(upperCase(surname))) {
      return `${name} ${surname}`;
    }
    return name;
  };

  return {
    sendLeads,
  };
};
